// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import claim from './claim';
import {combineReducers} from 'redux';
import modal from './modal';
import spaTypes from './spa-types';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    claim,
    modal,
    spaTypes
});



// WEBPACK FOOTER //
// ./src/tabm/spa-details/reducers/index.js